<script setup lang="ts">
import { useAuth } from '@clerk/vue'

const { isLoaded } = useAuth()
</script>

<template>
  <div class="app-container">
    <router-view v-if="isLoaded" />
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background: #f5f5f5;
}

.app-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
